export default __webpack_public_path__ + "static/media/Alert.a2c2d30f.svg";